import { ApiEndpoints } from '../apiEndpoints.constant';
import { post } from '../request';
import type { TokenInfo, TokenResponse } from '@/@types/validateToken';
import { APP_CONFIG } from '@/config';

export const validateToken = async (payload: TokenInfo): Promise<TokenResponse | null> => {
  return await post(`${APP_CONFIG.baseApiUrl}${ApiEndpoints.validateToken}`, payload, 'XSRF-TOKEN');
};
